import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Form } from 'src/app/services/forms/form';
import { EbService } from '../../eb.service';

@Component({
  selector: 'eb-main-s3',
  templateUrl: './eb-main-s3.component.html',
  styleUrls: ['./eb-main-s3.component.scss']
})
export class EbMainS3Component {

  @Input() form?: Form | null;
  @Input() disabled!: boolean;
  @Input() showAmendment!: boolean;
  @Input() service?: EbService;

}
